module.exports = {
	"articleTitle1": "Bring your own wine law may not entice student diners",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Red Hawk Bar & Grill",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/sundance-festival-helps-michigan-theater-and-local-businesses",
	"articleSnippet1": "Mar 20, 2014 ... Roger Hewitt, owner of Red Hawk Bar & Grill downtown, said the restaurant hasn'\nt made a decision yet but will likely follow a similar path.",
	"articleSnippet2": "Feb 5, 2013 ... Roger Hewitt, owner of the Red Hawk Bar and Grill, said the arts, culture and \nbusiness communities of Ann Arbor work closely together.",
	"foodRecommendations": [
		{
			"text": "Bet the burgers are good...?",
			"person": "Ian McKenzie"
		}
	],
	"articleTitle2": "Oldest - ",
	"address": "316 S State St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2788,
		"lng": -83.7411
	},
	"totalMisc": 0,
	"categories": {
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/redhawk.json
// module id = 960
// module chunks = 0